import type { InputTextPassThroughOptions } from 'primevue/inputtext'

const pt: InputTextPassThroughOptions = {
    root: ({ props }) => ({
        class: [
            'w-full px-3 py-2 rounded-6',
            'border border-gray-200 bg-white',
            'text-sm text-gray-900 placeholder:text-gray-400',
            'transition-colors duration-fast',
            'focus:border-teal focus:outline-none focus:ring-2 focus:ring-teal/20',
            'disabled:bg-gray-50 disabled:cursor-not-allowed',
            props.invalid && 'border-red focus:border-red focus:ring-red/20'
        ]
    })
}

export default pt
